import { useMemo } from 'react';

/**
 * This hook generates a deterministic render key based on the provided values.
 * This ensures that the component using this key will re-render whenever the values change.
 * This key is not guaranteed to be unique within a list.
 * It is only meant to change when there is a difference in an object of any depth.
 * @param {object | string} values
 * @returns {string} A string representation of the provided values.
 */
export const useRenderKey = (values: object | string): string => {
  const renderKey = useMemo(() => JSON.stringify(values), [values]);
  return renderKey;
};
